import Delete from '@react-spectrum/s2/icons/Delete';
import { iconStyle } from '@react-spectrum/s2/style' with { type: 'macro' };
import { Button as RACButton } from 'react-aria-components';

import type { ForYouTask } from '@/spaces/chat/useForYouTasks';
import { cn } from '@/utils/cn';

type ForYouTaskListProps = {
	tasks: ForYouTask[];
	onActivate: (task: ForYouTask) => void;
	onRemove: (task: ForYouTask) => void;
};

export const ForYouTaskList = ({
	tasks,
	onActivate,
	onRemove,
}: ForYouTaskListProps) => {
	if (tasks.length === 0) {
		return (
			<div className="px-5 py-3 text-center text-sm text-(--text-muted)">
				You&apos;re all caught up.
			</div>
		);
	}

	// The row and trash are siblings (not nested) so the DOM stays valid — a
	// <button> may not descend from another <button>. The trash overlaps the
	// row's reserved right padding; pressing it triggers onRemove only.
	return (
		<>
			{tasks.map((task, i) => (
				<div
					key={task.id}
					className={cn(
						'group relative',
						i > 0 && 'border-t border-black/[0.06]',
					)}
				>
					<RACButton
						onPress={() => onActivate(task)}
						className={cn(
							'flex w-full items-center justify-start px-5 py-3 pr-12 text-left',
							'text-sm leading-snug text-(--text-primary)',
							'cursor-pointer bg-transparent outline-none',
							'hover:bg-black/[0.025]',
						)}
					>
						{task.label}
					</RACButton>
					<RACButton
						aria-label="Remove suggestion"
						onPress={() => onRemove(task)}
						className="absolute top-1/2 right-3 flex h-5 w-5 shrink-0
							-translate-y-1/2 cursor-pointer items-center justify-center
							rounded-full opacity-0 outline-none group-hover:opacity-100
							hover:bg-black/5"
					>
						<Delete styles={iconStyle({ size: 'XS', color: 'gray' })} />
					</RACButton>
				</div>
			))}
		</>
	);
};
